import { Button, Theme, useMediaQuery } from "@mui/material";
import { hasChildren } from "misc/renderHelpers";
import { Button as RaButton, ButtonProps, useTranslate } from "react-admin";

/* TODO: This component should at some point be properly reworked.
  The main issue is that react admin per default shows an IconButton for small screens
  We have buttons without an icon which would show up empty on mobile
  The current solution is a workaround that should be refined for proper mobile support */

export default function EdmButton(props: ButtonProps) {
  const { size = "small", color, variant = "contained", children, label, ...buttonProps } = props;

  const translate = useTranslate();
  const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

  const finalColor = color ? color : isSmall ? "primary" : "info";

  if (isSmall && !hasChildren(children)) {
    return (
      <Button size={size} color={color} variant={variant} {...buttonProps}>
        {label && typeof label === "string" ? translate(label) : label}
      </Button>
    );
  }

  return (
    <RaButton size={size} color={finalColor} variant={variant} label={label} {...buttonProps}>
      {hasChildren(children) ? children : undefined}
    </RaButton>
  );
}
